import nodeIcon from "../images/skills/nodejs.svg";
import expressIcon from "../images/skills/expressjs.svg";
import mysqlIcon from "../images/skills/mysql.svg";
import reactIcon from "../images/skills/react.svg";
import reduxIcon from "../images/skills/redux.svg";
import typescriptIcon from "../images/skills/typescript.svg";
import javascriptIcon from "../images/skills/javascript.svg";
import tailwindIcon from "../images/skills/tailwind.svg";
import cssIcon from "../images/skills/css.svg";
import htmlIcon from "../images/skills/html.svg";

const skills = [
    {
        name: "Node",
        textColor: "text-lime-900",
        bgColor: "bg-lime-300",
        bgColorLight: "bg-lime-100",
        icon: nodeIcon,
        shadow: "hover:shadow-lime-200",
    },
    {
        name: "Express",
        textColor: "text-stone-900",
        bgColor: "bg-stone-300",
        bgColorLight: "bg-stone-100",
        icon: expressIcon,
        shadow: "hover:shadow-stone-200",
    },
    {
        name: "React",
        textColor: "text-cyan-900",
        bgColor: "bg-cyan-300",
        bgColorLight: "bg-cyan-100",
        icon: reactIcon,
        shadow: "hover:shadow-cyan-200",
    },
    {
        name: "TypeScript",
        textColor: "text-sky-900",
        bgColor: "bg-sky-300",
        bgColorLight: "bg-sky-100",
        icon: typescriptIcon,
        shadow: "hover:shadow-sky-200",
    },
    {
        name: "Redux",
        textColor: "text-purple-900",
        bgColor: "bg-purple-300",
        bgColorLight: "bg-purple-100",
        icon: reduxIcon,
        shadow: "hover:shadow-purple-200",
    },
    {
        name: "MySQL",
        textColor: "text-blue-900",
        bgColor: "bg-blue-300",
        bgColorLight: "bg-blue-100",
        icon: mysqlIcon,
        shadow: "hover:shadow-blue-200",
    },
    {
        name: "Javascript",
        textColor: "text-yellow-900",
        bgColor: "bg-yellow-300",
        bgColorLight: "bg-yellow-100",
        icon: javascriptIcon,
        shadow: "hover:shadow-yellow-200",
    },
    {
        name: "Tailwind CSS",
        textColor: "text-sky-900",
        bgColor: "bg-sky-300",
        bgColorLight: "bg-sky-100",
        icon: tailwindIcon,
        shadow: "hover:shadow-sky-200",
    },
    {
        name: "CSS",
        textColor: "text-blue-900",
        bgColor: "bg-blue-300",
        bgColorLight: "bg-blue-100",
        icon: cssIcon,
        shadow: "hover:shadow-blue-200",
    },
    {
        name: "HTML",
        textColor: "text-orange-900",
        bgColor: "bg-orange-300",
        bgColorLight: "bg-orange-100",
        icon: htmlIcon,
        shadow: "hover:shadow-orange-200",
    },
];

export default skills;
